import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { IJob } from 'wisestep-api';
import { WsSelectObj } from 'wisestep-base';

import { fetchBusinessUnits } from '../helper';
import { useListingSettings } from '../listing/hooks';

import JDGeneratorDialog from './components/JDGeneratorDialog';
import JDUploadOrPasteDialogue from './components/JDUploadOrPasteDialogue';
import JobPostingChoice from './components/JobPostingChoice';
import JobPostingForm from './components/JobPostingForm';

export interface IPostNewJob {
  manualPosting: boolean;
}

export const PostNew = () => {
  const location: any = useLocation();

  const [postingChoice, setPostingChoice] = useState<'form' | 'upload' | 'choice' | 'jdGenerator'>(
    'choice'
  );
  //const [openDialogue, setOpenDialogue] = useState<boolean>(true);
  const [jobEntity, setJobEntity] = useState<IJob>({ workplacePreference: 'Onsite' });
  const { jobFieldSettings } = useListingSettings();
  const onDialogueAction = (action: string) => action && setPostingChoice('choice');
  const [businessUnits, setBusinessUnits] = useState<WsSelectObj[]>([]);
  const onJDParsing = (job: IJob) => {
    setJobEntity(job);
    setPostingChoice('form');
  };

  const onJDGeneration = (job: IJob) => {
    setJobEntity(job);
    setPostingChoice('form');
  };

  useEffect(() => {
    fetchBusinessUnits(setJobEntity, setBusinessUnits);
  }, []);

  useEffect(() => {
    if (location.state?.selectedClientInfo) {
      setPostingChoice('form');
      const jobEntityData: IJob = {};
      jobEntityData.companyName = location.state?.selectedClientInfo
        .map((client) => client.data.clientNameToNewJob)
        .toString();
      jobEntityData.clientId = location.state?.selectedClientInfo
        .map((client) => client.data.clientIdNameToNewJob)
        .toString();
      setJobEntity(jobEntityData);
    }
  }, [location.state?.selectedClientInfo]);

  return (
    <>
      {postingChoice === 'choice' ? (
        <JobPostingChoice
          onChoiceSelection={(choice) =>
            setPostingChoice(
              choice === 'upload' ? 'upload' : choice === 'form' ? 'form' : 'jdGenerator'
            )
          }
        ></JobPostingChoice>
      ) : (
        ''
      )}
      {postingChoice === 'upload' ? (
        <JDUploadOrPasteDialogue
          open={postingChoice === 'upload'}
          onClose={onDialogueAction}
          onJDParsing={onJDParsing}
        />
      ) : (
        ''
      )}
      {postingChoice === 'form' ? (
        <div>
          <JobPostingForm
            jobEntity={jobEntity}
            jobFieldSettings={jobFieldSettings}
            onNavigateBack={onDialogueAction}
            businessUnits={businessUnits}
          ></JobPostingForm>
        </div>
      ) : (
        ''
      )}
      {postingChoice === 'jdGenerator' ? (
        <JDGeneratorDialog
          open={postingChoice === 'jdGenerator'}
          onClose={onDialogueAction}
          onJDGeneration={onJDGeneration}
        />
      ) : (
        ''
      )}
    </>
  );
};
